// dominas.
import { useOrchestratorSteps } from '@domains/orchestrator-pricing-committee/hooks/useOrchestratorSteps';

export const TrackerEmpty = () => {
  const { steps } = useOrchestratorSteps();

  if (steps.length === 0) return null;

  return (
    <div className="p-3">
      {steps.map((stepName, idx) => {
        const keyAux = `step-${idx}-${stepName.replace(/\s+/g, '-')}`;
        return (
          <div
            key={keyAux}
            className="d-flex align-items-center mb-3 text-muted"
          >
            <div className="me-2">•</div>
            <div>{stepName} (no data)</div>
          </div>
        );
      })}
    </div>
  );
};
